var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Grid, Dialog, DialogActions, DialogContent, DialogTitle, Paper, } from '@material-ui/core';
import Draggable from 'react-draggable';
import { MdClose } from 'react-icons/md';
import { makeStyles } from '@material-ui/core/styles';
// Going to use this until we decide how we wanna handle styles. Don't want to port fully to material UI
// at this stage.
var useFormPopupStyles = makeStyles(function (theme) { return ({
    formPopupTitleWrapper: {
        cursor: 'move',
        backgroundColor: theme.commonSettings.popupTitleColor || theme.palette.secondary.main,
        color: theme.palette.common.white,
        textAlign: 'center',
        padding: theme.spacing(1, 2),
    },
    formPopupTitle: {
        fontSize: '1.3rem',
        fontWeight: 'bold',
    },
    closeIcon: {
        fontSize: '1.8rem',
        cursor: 'pointer',
    },
    dialogContent: function (props) { return ({
        borderRadius: props.contentObject.title === undefined ? theme.shape.borderRadius : 0,
    }); },
}); });
// this cancel prop, is to prevent the draggable when clicking inside the content
// for selecting purposes e.g.
function PaperComponent(props) {
    return (React.createElement(Draggable, { cancel: '[class*="MuiDialogContent-root"], [class*="MuiMenu-paper"]' },
        React.createElement(Paper, __assign({}, props))));
}
/**
 * @deprecated
 * Use `FormPopup` to render a popup with custom content.
 */
export default function FormPopup(props) {
    var closePopup = props.closePopup, contentObject = props.contentObject, hideHeader = props.hideHeader;
    var title = contentObject.title, body = contentObject.body, footer = contentObject.footer;
    var classes = useFormPopupStyles(props);
    return (React.createElement(Dialog, { onClose: closePopup, PaperComponent: PaperComponent, "aria-labelledby": 'draggable-dialog-title', open: true, disableEnforceFocus: true },
        !hideHeader && (React.createElement(DialogTitle, { className: classes.formPopupTitleWrapper, id: 'draggable-dialog-title', disableTypography: true },
            React.createElement(Grid, { container: true, alignItems: 'center' },
                React.createElement(Grid, { item: true, xs: 11, className: classes.formPopupTitle }, title),
                React.createElement(Grid, { item: true, xs: 1 },
                    React.createElement(MdClose, { onClick: closePopup, className: classes.closeIcon }))))),
        React.createElement(DialogContent, null, body),
        footer ? React.createElement(DialogActions, null, footer) : null));
}
//# sourceMappingURL=FormPopup.js.map